import { render, staticRenderFns } from "./RepairPartsCFRStatistic.vue?vue&type=template&id=99913602"
import script from "./RepairPartsCFRStatistic.vue?vue&type=script&lang=js"
export * from "./RepairPartsCFRStatistic.vue?vue&type=script&lang=js"
import style0 from "./RepairPartsCFRStatistic.vue?vue&type=style&index=0&id=99913602&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports